import React from "react";
import { X, MapPin, Phone, CreditCard, FileText } from "lucide-react";
import { formatTL } from "@/lib/api";

export default function OrderDetailModal({ order, onClose }) {
  if (!order) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="order-detail-modal">
      <div className="bg-white max-w-2xl w-full max-h-[90vh] overflow-auto rounded-sm" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-ink-200 sticky top-0 bg-white">
          <div>
            <div className="font-display font-black text-xl">Sipariş Detayı</div>
            <div className="font-mono text-sm text-ink-500">{order.order_number}</div>
          </div>
          <button onClick={onClose} data-testid="close-modal" className="p-2 hover:bg-ink-100"><X size={20}/></button>
        </div>
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <div className="text-xs text-ink-500 uppercase">Sipariş Tarihi</div>
              <div className="font-semibold">{new Date(order.created_at).toLocaleString("tr-TR")}</div>
            </div>
            <div>
              <div className="text-xs text-ink-500 uppercase">Ödeme Yöntemi</div>
              <div className="font-semibold flex items-center gap-1"><CreditCard size={14}/>{order.payment_method === "stripe" ? "Kredi Kartı" : order.payment_method === "havale" ? "Havale/EFT" : "Cari Hesap"}</div>
            </div>
            <div>
              <div className="text-xs text-ink-500 uppercase">Ödeme Durumu</div>
              <span className={`inline-block text-[10px] px-2 py-0.5 font-bold ${order.payment_status === "paid" ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"}`}>{order.payment_status.toUpperCase()}</span>
            </div>
            <div>
              <div className="text-xs text-ink-500 uppercase">Sipariş Durumu</div>
              <span className="inline-block text-[10px] px-2 py-0.5 font-bold bg-ink-100">{order.order_status.toUpperCase()}</span>
            </div>
          </div>

          <div>
            <h4 className="font-semibold flex items-center gap-2 mb-2"><MapPin size={14}/> Teslimat Adresi</h4>
            <div className="text-sm bg-ink-100 p-3">{order.shipping_address}</div>
            <div className="text-xs text-ink-500 mt-2 flex items-center gap-1"><Phone size={12}/> {order.phone}</div>
          </div>

          {order.notes && (
            <div>
              <h4 className="font-semibold flex items-center gap-2 mb-2"><FileText size={14}/> Sipariş Notu</h4>
              <div className="text-sm bg-ink-100 p-3">{order.notes}</div>
            </div>
          )}

          <div>
            <h4 className="font-semibold mb-3">Ürünler ({order.items.length})</h4>
            <div className="border border-ink-200">
              {order.items.map((it, idx) => (
                <div key={`${it.product_id}-${idx}`} className="flex items-center gap-3 p-3 border-b border-ink-200 last:border-0">
                  {it.image_url && <img src={it.image_url} alt="" className="w-14 h-14 object-cover bg-ink-100"/>}
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold truncate">{it.name}</div>
                    <div className="text-xs font-mono text-ink-500">{it.sku}</div>
                    <div className="text-xs text-ink-500">{it.quantity} × {formatTL(it.unit_price)} (KDV hariç)</div>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-bold">{formatTL((it.unit_price + (it.unit_kdv || 0)) * it.quantity)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="border-t border-ink-200 pt-4 space-y-1 text-sm">
            {order.subtotal !== undefined && (
              <>
                <div className="flex justify-between"><span className="text-ink-500">Ara Toplam (KDV hariç)</span><span className="font-semibold">{formatTL(order.subtotal)}</span></div>
                <div className="flex justify-between"><span className="text-ink-500">KDV (%20)</span><span className="font-semibold">{formatTL(order.kdv_total || 0)}</span></div>
              </>
            )}
            <div className="flex justify-between text-lg font-display font-black pt-2 border-t border-ink-200">
              <span>Genel Toplam</span><span>{formatTL(order.total)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
